const startupInFlight = new Map();
const startupResolved = new Map();
export function runStartupRequest(key, loader, options = {}) {
    if (options.cacheResult && startupResolved.has(key)) {
        return Promise.resolve(startupResolved.get(key));
    }
    const existing = startupInFlight.get(key);
    if (existing) {
        return existing;
    }
    const request = loader()
        .then((result) => {
        if (options.cacheResult) {
            startupResolved.set(key, result);
        }
        return result;
    })
        .finally(() => {
        startupInFlight.delete(key);
    });
    startupInFlight.set(key, request);
    return request;
}
